import React from "react";
import { Grid, CardContent, CardHeader, Divider, Card, Fab } from "@material-ui/core";
import OrderIndTable from "./OrderIndTable";
import { usePageStyles } from "../../pageStyles";
import { SearchBox } from "../../components/common/SearchBox";
import { PageComponent, AccessRights } from "../../../core/navigation/types";
import {
	PaginationTable,
	PaginationDataProps,
} from "../../components/common/PagginationTable";
import AddIcon from "@material-ui/icons/Add";
import { useHistory } from "react-router-dom";
import { PageTitle } from "../../components/common/PageTitle";
import { getOrderIndEditLocation } from "./Locations";
import { useOrderIndData } from "../../../data/trading/orderIndicative/hooks/useOrderIndData";
import { useOrderIndIndex } from "../../../data/trading/orderIndicative/hooks/useOrderIndIndex";
import { useAuth } from "../../../data/auth/hooks";
import { OrderIndFilterButton } from "./OrderIndFilter";
import { useNotificationHandler } from "../../../core/notifications/hooks";

const OrderIndPage: PageComponent = ({ userAccessRights }) => {
	const pageStyles = usePageStyles();

	const [pageData, dispatchLoadOrderInd, allData, invalidateData] = useOrderIndData();
	const [pageIndex, dispatchSetIndex] = useOrderIndIndex();

	const history = useHistory();

	const [auth] = useAuth();

	React.useEffect(() => {
		if (auth.status === "successful") {
			dispatchLoadOrderInd();
		}
	}, [auth.status, dispatchLoadOrderInd]);

	useNotificationHandler<string>(
		"OrderIndChanged",
		e => {
			console.log("OrderIndChanged", e);
			dispatchLoadOrderInd();
		},
		[dispatchLoadOrderInd]
	);

	if (auth.status !== "successful") {
		return null;
	}



	return (
		<Grid container className={pageStyles.root}>
			<Grid item xs={12} className={pageStyles.gridItem}>
				<Card>
					<CardHeader
						title={<PageTitle title="navOrderIndicative" />}
						action={<OrderIndFilterButton />}
					/>
					<Divider />
					<CardContent>
						<CardContent>
							<OrderIndTable
								pageData={pageData}
								pageIndex={pageIndex}
								onPageIndexChange={dispatchSetIndex}
								userAccessRights={userAccessRights}
								getData={dispatchLoadOrderInd}
							//							pageIndex={pageIndex}
							//							immutableData={pageData}
							//							onPageIndexChange={dispatchSetIndex}
							//							userAccessRights={userAccessRights}
							//							getData={dispatchLoadOrderInd}
							/>
						</CardContent>
					</CardContent>
				</Card>
				{/*		{userAccessRights === AccessRights.All && (
					<Fab
						color="secondary"
						aria-label="add"
						className={pageStyles.mainFab}
						onClick={() => history.push(getOrderIndEditLocation())}
					>
						<AddIcon />
					</Fab>
				)} */}

				<Fab
					color="secondary"
					aria-label="add"
					className={pageStyles.mainFab}
					onClick={() => history.push(getOrderIndEditLocation())}
				>
					<AddIcon />
				</Fab>

			</Grid>
		</Grid>
	);
};

export default OrderIndPage;
